import axios from 'axios';

export const GET_TEMPLATES = 'lms/course-templates';

export function getTemplates(params) {
  return axios.get(GET_TEMPLATES);
}
